import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import MemberVouchers, {
  VoucherData,
  VoucherDisplayType,
} from "@/features/Common/components/MemberVouchers";
import useGetMemberVouchers from "@/features/Vouchering/hooks/useGetMyVouchers";
import { MemberServiceOfferingType } from "@/services/core-api-adapter";

export default function MyCareCardVouchers() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { memberVouchers, isMemberVouchersLoading, memberVouchersFetchError } =
    useGetMemberVouchers();

  function onVoucherPanelClick(voucher: VoucherData) {
    navigate(
      `/home/get-medical-assistance/vouchers?orderId=${voucher.voucherOrderId}&isMyVouchers=true`
    );
  }

  function onUseVoucherNowClick(voucher: any) {
    if (voucher.serviceOfferingType === MemberServiceOfferingType.PATHOLOGY) {
      navigate("/home/get-medical-assistance/pathology?voucher=true");
    } else {
      navigate("/home/get-medical-assistance/intercare?voucher=true");
    }
  }

  return (
    <MemberVouchers
      voucherDisplayType={VoucherDisplayType.CareCardVoucher}
      title={t("More.MyVouchers.title")}
      memberVoucherItems={memberVouchers}
      isMemberVouchersLoading={isMemberVouchersLoading}
      memberVouchersFetchError={memberVouchersFetchError}
      onPanelClick={onVoucherPanelClick}
      onActionClick={onUseVoucherNowClick}
      backNavigationPath="/home/more"
    />
  );
}
